module.exports = __webpack_public_path__ + "img/network.1fc87f8f.png";